import { render, staticRenderFns } from "./skiiScoreListWZ.vue?vue&type=template&id=117da910&scoped=true"
import script from "./skiiScoreListWZ.vue?vue&type=script&lang=js"
export * from "./skiiScoreListWZ.vue?vue&type=script&lang=js"
import style0 from "./skiiScoreListWZ.vue?vue&type=style&index=0&id=117da910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117da910",
  null
  
)

export default component.exports